import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';

export interface Rppk14QueryParams {
  siteId: number;
  status?: string | null;
  clientId?: number | null;
  vehicleTypeId?: number | null;
  subscriptionId?: number | null;
  searchField?: string | null;
  searchText?: string | null;
}

@Injectable({ providedIn: 'root' })
export class ApiRppk14Service {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);
  private readonly http = inject(HttpClient);

  getRppk14ForTable(query: Rppk14QueryParams): Observable<unknown> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = { siteId: query.siteId };
    if (query.status) params['status'] = query.status;
    if (query.clientId && query.clientId > 0) params['clientId'] = query.clientId;
    if (query.vehicleTypeId && query.vehicleTypeId > 0) params['vehicleTypeId'] = query.vehicleTypeId;
    if (query.subscriptionId && query.subscriptionId > 0) params['subscriptionId'] = query.subscriptionId;
    if (query.searchField) params['searchField'] = query.searchField;
    if (query.searchText) params['searchText'] = query.searchText;

    return this.apiMethodService.request('/FinanceReports/getRppk14ForTable', 'GET', this.baseUrl, {
      isConsoleLog: false,
      labelLog: 'getRppk14ForTable',
      token,
      headerOnly: false,
      params,
    });
  }

  getRppk14Pdf(query: Rppk14QueryParams): Observable<Uint8Array> {
    const token = this.cookieService.get('token');
    let params = new HttpParams().set('siteId', String(query.siteId));
    if (query.status) params = params.set('status', query.status);
    if (query.clientId && query.clientId > 0) params = params.set('clientId', String(query.clientId));
    if (query.vehicleTypeId && query.vehicleTypeId > 0) {
      params = params.set('vehicleTypeId', String(query.vehicleTypeId));
    }
    if (query.subscriptionId && query.subscriptionId > 0) {
      params = params.set('subscriptionId', String(query.subscriptionId));
    }
    if (query.searchField) params = params.set('searchField', query.searchField);
    if (query.searchText) params = params.set('searchText', query.searchText);

    return this.http
      .get(`${this.baseUrl}/Reports/rppk14/pdf`, {
        headers: new HttpHeaders({ Authorization: `Bearer ${token}` }),
        params,
        responseType: 'arraybuffer',
      })
      .pipe(map((buf) => new Uint8Array(buf)));
  }
}
